import {RiCheckFill} from 'react-icons/ri';
import clsx from 'clsx';
interface Step {
	id: number;
	label: string;
}

interface ProgressStepperProps {
	currentStep: number;
	step1Label?: string;
	step2Label?: string;
	step3Label?: string;
	step4Label?: string;
	customSteps?: {
		id: number;
		label: string;
	}[];
	shoppingCart?: boolean;
}

export default function ProgressStepper({
	currentStep,
	step1Label,
	step2Label,
	step3Label,
	step4Label,
	customSteps,
	shoppingCart = false,
}: ProgressStepperProps) {
	const steps: Step[] = customSteps
		? customSteps
		: shoppingCart
			? [
					{id: 1, label: 'Handlevogn'},
					{id: 2, label: 'Leverandør'},
					{id: 3, label: 'Frakt'},
					{id: 4, label: 'Betaling'},
				]
			: [
					{id: 1, label: 'Åpning'},
					{id: 2, label: 'Størrelse'},
					{id: 3, label: 'Tilpasninger'},
					{id: 4, label: 'Bestilling'},
				];

	return (
		<ul className="mt-10 flex max-w-[250px] overflow-x-auto max-sm:mt-4 [@media(min-width:320px)]:max-w-[500px]">
			{steps.map((step) => (
				<li
					key={step.id}
					className={clsx(
						'relative',
						'flex',
						'min-w-[75px]',
						'flex-col',
						'items-center',
						'after:absolute',
						'after:top-[12px]',
						'after:left-1/2',
						'after:h-[2px]',
						'after:w-full',
						currentStep === step.id
							? 'after:bg-[#E6E4E3]'
							: currentStep > step.id
								? 'after:bg-[#83BA53]'
								: 'after:bg-[#E6E4E3]',
						'last-of-type:after:hidden',
					)}
				>
					<div
						className={`z-10 flex size-[24px] items-center justify-center rounded-full text-[12px] font-bold transition-all 
									${
										currentStep === step.id
											? 'border-2 border-[#83BA53] bg-white text-black'
											: currentStep > step.id
												? 'border-[#83BA53] bg-[#83BA53] text-white'
												: 'border-2 border-border-medium bg-white text-gray-400'
									}`}
					>
						{currentStep > step.id ? (
							<RiCheckFill className="size-5" color="white" />
						) : (
							step.id
						)}
					</div>
					<span
						className={`mt-2 max-w-24 text-balance px-2 text-center text-[12px] font-semibold capitalize ${
							currentStep === step.id
								? 'text-black'
								: currentStep > step.id
									? 'text-gray-600'
									: 'text-gray-400'
						}`}
					>
						{(step.id === 1 && step1Label) ||
							(step.id === 2 && step2Label) ||
							(step.id === 3 && step3Label) ||
							(step.id === 4 && step4Label) ||
							step.label}
					</span>
				</li>
			))}
		</ul>
	);
}
